// Recognising a page chunk that failed to load, and reloading for it at most once. Pure, so
// `chunkError.test.ts` can run it under Node.

/** The wording of Chrome, Firefox, Safari, and Vite's CSS preloader. */
const CHUNK_ERROR =
  /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|unable to preload css/i;

export function isChunkError(error: unknown): boolean {
  return error instanceof Error && CHUNK_ERROR.test(error.message);
}

const KEY = "mixla.chunkReloadAt";
/** A failure this soon after a reload means reloading doesn't help, so the user gets a button. */
const RELOAD_WINDOW_MS = 30_000;

type Store = Pick<Storage, "getItem" | "setItem">;

export function canAutoReload(store: Store, now: number): boolean {
  const last = Number(store.getItem(KEY));
  return !last || now - last > RELOAD_WINDOW_MS;
}

export function markAutoReload(store: Store, now: number): void {
  store.setItem(KEY, String(now));
}
